import {
  React,
  Component
} from 'imports/CommonImports';

import {Paper} from 'material-ui';

const styles = {
  container: {
    padding: '0.1em 0 2em 0',
  },
  title: {
    paddingLeft: '1em',
    marginBottom: '1em',
  },
  message: {
    paddingLeft: '2em',
    marginBottom: '1em',
  },
}

class Waiting extends Component {
  render() {
    return (
      <Paper style={styles.container}>
        <h1 style={styles.title}>{this.props.title}</h1>
        <h3 style={styles.message}>{this.props.message}</h3>
       </Paper>
    );
  }
}

export default Waiting;



// WEBPACK FOOTER //
// ./src/components/design/Waiting.js